module.exports = __webpack_public_path__ + "img/alerts_yellow.79d38533.svg";